module.exports = __webpack_public_path__ + "img/advantage1@2x.ea1c5f21.png";